import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import type { MasterControlAuditLog } from "@/hooks/useMasterControl";

type MCAuditLogDrawerProps = {
  log: MasterControlAuditLog | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function MCAuditLogDrawer({ log, open, onOpenChange }: MCAuditLogDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="bg-background text-foreground">
        <DrawerHeader>
          <DrawerTitle>Audit entry</DrawerTitle>
          <p className="text-sm text-muted-foreground">Full payload for action history.</p>
        </DrawerHeader>
        <div className="border-t border-border px-6 py-4 space-y-3 text-sm text-foreground/80">
          {log ? (
            <>
              <div className="grid gap-2 md:grid-cols-2">
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">Timestamp</p>
                  <p>{new Date(log.timestamp).toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">Actor</p>
                  <p>{log.actor_user_id ?? "owner"}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">Action</p>
                  <p>{log.action}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">Target</p>
                  <p>{log.target_identifier ?? log.target_type ?? "—"}</p>
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">Status</p>
                  <p className={log.success ? "text-emerald-300" : "text-rose-300"}>{log.success ? "Successful" : "Failed"}</p>
                </div>
                {log.message && (
                  <div>
                    <p className="text-xs uppercase tracking-wide text-muted-foreground">Message</p>
                    <p className="text-rose-300">{log.message}</p>
                  </div>
                )}
              </div>
              <div>
                <p className="text-xs uppercase tracking-wide text-muted-foreground">Payload</p>
                <pre className="mt-2 max-h-72 overflow-auto rounded-xl border border-border bg-background p-4 text-xs text-foreground/70">
                  {JSON.stringify(log.payload ?? {}, null, 2)}
                </pre>
              </div>
            </>
          ) : (
            <p className="text-muted-foreground">Select an entry to view details.</p>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export default MCAuditLogDrawer;
